import {axios as http} from "@/plugins/http"

export default class Api {
    static auth(limit) {
        return http.post("/api/v1/statistic/actions/auth", {
            limit: limit,
        }).then((resp) => {
            return resp.data["data"]
        })
    }

    static event(limit) {
        return http.post("/api/v1/statistic/actions/event", {
            limit: limit,
        }).then((resp) => {
            return resp.data["data"]
        })
    }

    static notify(limit) {
        return http.post("/api/v1/statistic/actions/notify", {
            limit: limit,
        }).then((resp) => {
            return resp.data["data"]
        })
    }

    static post(limit) {
        return http.post("/api/v1/statistic/actions/post", {
            limit: limit,
        }).then((resp) => {
            return resp.data["data"]
        })
    }

    static resource(limit) {
        return http.post("/api/v1/statistic/actions/resource", {
            limit: limit,
        }).then((resp) => {
            return resp.data["data"]
        })
    }
}
